import { defineComponent as _defineComponent } from 'vue'
import ChangesDetection from '@/components/commons/ChangesDetection.vue';
import {useScheduleStore} from '@/components/calculator/services/ScheduleStore';
import {computed} from 'vue';
import {SimulationDemand} from '@/models/Demand';
import {debouncedAtInput} from '@/services/utils/BasicUtils';
import {useInstance} from '@/composables/useInstance';
import ScheduleAdditionalCostsTable from '@/components/calculator/schedule/ScheduleAdditionalCostsTable.vue';
import {I18NGetter} from "../../../services/enumTranslator/I18NGetter";


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleOptionsAccordion',
  props: {
    value: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ((event: 'update:modelValue', value: SimulationDemand) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: SimulationDemand;
}





const scheduleStore = useScheduleStore();
const {schedule,} = scheduleStore;
const {$i18n, $env,} = useInstance();
const emitInput = (value: SimulationDemand) => {
  emit('update:modelValue', value);
};

const model = computed<SimulationDemand>({
  get: () => props.value,
  set: (newValue: SimulationDemand) => emitInput(newValue),
});

const fetchSchedule: void = debouncedAtInput(() => emit('fetchSchedule'));

return { __sfc: true,props, emit, scheduleStore, schedule, $i18n, $env, emitInput, model, fetchSchedule, ChangesDetection, ScheduleAdditionalCostsTable, I18NGetter }
}

})